<template>
  <fragment>
    <div v-if="!hideMainProduct" class="productForm">
      <table class="table productForm__productTable">
        <thead>
          <tr>
            <th scope="col" class="col-sm-5">Produkt</th>
            <th scope="col" class="col-sm-2">Liczba</th>
            <th scope="col" class="col-sm-2">Wartość</th>
            <th scope="col" class="col-sm-3 col-md-2">SUMA</th>
          </tr>
        </thead>
        <tbody class="productForm__rows">
          <tr v-for="(product, idx) in getProducts" :key="product.idproducts + idx">
            <product-row-form
              :product="product"
              :delivery_id="delivery_id"
              :main="main"
              @updateProduct="updateProduct"
            />
          </tr>
          <tr v-for="(product, idx) in getPromoProducts" :key="product.idproducts + idx">
            <product-row-form
              :product="product"
              :delivery_id="delivery_id"
              @updateProduct="updateProduct"
            />
          </tr>
        </tbody>
      </table>
      <div class="add-product" v-if="canAddLine">
        <button type="button" class="btn btn-outline-primary" @click="addProduct">
          Dodaj kolejną pozycję
        </button>
      </div>
    </div>
    <div v-if="currentStep === stepType.START && checkIsConfectionAvailable">
      <h2 class="productForm__serviceTable__header">Usługi</h2>
      <div class="productForm">
        <table class="table productForm__serviceTable">
          <thead>
            <tr>
              <th scope="col" class="col-sm-7">Usługi dodatkowe</th>
              <th scope="col" class="col-sm-3"></th>
              <th scope="col" class="col-sm-2">SUMA</th>
            </tr>
          </thead>
          <tbody class="productForm__rows">
            <template v-if="hasProductNDEConfection">
              <tr v-if="hasContractIndividualConfection">
                <td colspan="3" class="px-0">
                  <CustomAlert type="info" class="productForm__alert mb-0">
                    <template #icon>
                      <span class="alert__icon mi mi-info-fill"></span>
                    </template>
                    <p class="m-0" v-html="getIncompleteNDEConfectionMessage"></p>
                  </CustomAlert>
                </td>
              </tr>
              <template v-for="type in getNDEConfectionTypeOrder()">
                <n-d-e-confection-header-form
                  v-if="hasNDEConfectionByType(product, type)"
                  :key="type"
                  :header="getConfectionHeader(type)"
                  :isNew="type === confectionType.APP"
                >
                  <template #description>
                    <span
                      v-if="type === confectionType.PERSONALIZED"
                      class="font-weight-normal d-block mt-1"
                    >
                      Uwaga! Możesz wybrać
                      <strong class="font-weight-bold">tylko jedną</strong> opcję personalizacji.
                    </span>
                    <span
                      v-else-if="type === confectionType.APP"
                      class="font-weight-normal d-block mt-1"
                    >
                      Obdarowani kartami Pluxee mogą zobaczyć w aplikacji Pluxee kto i za co
                      przekazał im kartę.
                      <br />
                      <a
                        href="#"
                        @click.prevent="handleModalOpen"
                        class="d-block mt-2 app-confection-modal__link"
                        >Sprawdź, jak może wyglądać personalizacja
                      </a>
                      <confection-modal
                        @handleModalOpen="handleModalOpen"
                        :is-open="isConfectionModalOpen"
                        :modal-type="modalType.NDE_APP_CONFECTION"
                      />
                    </span>
                  </template>
                </n-d-e-confection-header-form>
                <n-d-e-confection-row-form
                  v-for="item in getNDEConfectionByType(product, type)"
                  :key="item.idproducts"
                  :deliveryId="delivery_id"
                  :item="item"
                  :exclusiveChoice="isConfectionTypeExclusive(type)"
                  :canEnterAmount="isConfectionAmountEnterable(item)"
                  isMainForm
                  :disabled="isConfectionReadOnly(item)"
                >
                  <template #inputs>
                    <n-d-e-confection-granting-form v-if="shouldShowConfectionGranting(item)" />
                    <LogoPersonalizationAlert
                      v-else-if="shouldShowLogoPersonalizationAlert(item)"
                    />
                    <n-d-e-confection-envelope-layout-form
                      v-else-if="shouldShowEnvelopeLayout(item)"
                    />
                    <n-d-e-confection-split-criteria-form
                      v-else-if="shouldShowSplitCriteria(item)"
                    />
                    <n-d-e-confection-personalization-form
                      v-else-if="shouldShowEnvelopePersonalization(item)"
                    >
                      <template #label-shared>
                        Chcę <b>taki sam</b> nadruk na wszystkich kopertach
                      </template>
                      <template #label-individual>
                        Chcę <b>różny</b> nadruk na kopertach
                      </template>
                    </n-d-e-confection-personalization-form>
                    <n-d-e-confection-personalization-form
                      v-else-if="shouldShowEtuiPersonalization(item)"
                    >
                      <template #label-shared>
                        Chcę <b>taki sam</b> nadruk na każdym etui
                      </template>
                      <template #label-individual>
                        Chcę <b>różny</b> nadruk na etui
                      </template>
                    </n-d-e-confection-personalization-form>
                  </template>
                </n-d-e-confection-row-form>
              </template>
            </template>
            <template v-else>
              <tr v-if="getProductsConfection && getProductsConfection.length > 0">
                <td colspan="3" class="text-left">
                  <span class="productForm__serviceTable__sectionHeader">{{
                    confectionHeader
                  }}</span>
                </td>
              </tr>
              <confection-row-form
                v-for="item in getProductsConfection"
                :key="item.idproducts"
                :delivery_id="delivery_id"
                :confectionItem="item"
              />
              <tr v-if="getProductsConfectionService && getProductsConfectionService.length > 0">
                <td colspan="3" class="text-left">
                  <span class="productForm__serviceTable__sectionHeader">Dodatkowe usługi</span>
                </td>
              </tr>
              <confection-service-row-form
                v-for="(item, i) in getProductsConfectionService"
                :key="item.idproducts"
                :delivery_id="delivery_id"
                :confectionItem="item"
                :isConfectionEnabled="isConfectionEnabled"
                @item-select="val => handleItemSelect(val, i)"
              />
            </template>
          </tbody>
        </table>
      </div>
    </div>
    <div
      class="productForm"
      v-if="currentStep === stepType.DELIVERY && showSelectedConfectionTable"
    >
      <table class="table productForm__serviceTable">
        <thead>
          <tr>
            <th scope="col" class="col-sm-7">Usługi dodatkowe</th>
            <th scope="col" class="col-sm-3"></th>
            <th scope="col" class="col-sm-2">SUMA</th>
          </tr>
        </thead>
        <tbody class="productForm__rows">
          <template v-if="hasProductNDEConfection">
            <template v-for="type in getNDEConfectionTypeOrder()">
              <n-d-e-confection-header-form
                v-if="hasSelectedNDEConfectionByType(type)"
                :key="type"
                :header="getConfectionHeader(type)"
              />
              <n-d-e-confection-row-form
                v-for="item in getSelectedNDEConfectionByType(type)"
                :key="item.idproducts"
                :deliveryId="delivery_id"
                :item="item"
                :exclusiveChoice="isConfectionTypeExclusive(type)"
                :canEnterAmount="isConfectionAmountEnterable(item)"
                :disabled="!isConfectionAmountEnterable(item)"
              >
                <template #action>
                  <a
                    v-if="!isConfectionAmountEnterable(item)"
                    href="#"
                    @click.prevent="goToFirstStep"
                  >
                    Zmień usługę dodatkową
                  </a>
                </template>
              </n-d-e-confection-row-form>
            </template>
          </template>
          <template v-else>
            <tr v-if="getSelectedConfection && getSelectedConfection.length > 0">
              <td colspan="3" class="text-left">
                <span class="productForm__serviceTable__sectionHeader">{{ confectionHeader }}</span>
              </td>
            </tr>
            <confection-row-form
              v-for="item in getSelectedConfection"
              :key="item.idproducts"
              :delivery_id="delivery_id"
              :confectionItem="item"
            />
            <tr v-if="getSelectedConfectionService && getSelectedConfectionService.length > 0">
              <td colspan="3" class="text-left">
                <span class="productForm__serviceTable__sectionHeader">Dodatkowe usługi</span>
              </td>
            </tr>
            <confection-service-row-form
              v-for="item in getSelectedConfectionService"
              :key="item.idproducts"
              :delivery_id="delivery_id"
              :confectionItem="item"
              :isConfectionEnabled="isConfectionEnabled"
            />
          </template>
        </tbody>
      </table>
    </div>
  </fragment>
</template>

<script>
import { mapState } from 'vuex';
import CustomAlert from '../CustomAlert.vue';
import ProductRowForm from './ProductRowForm.vue';
import ConfectionRowForm from './ConfectionRowForm.vue';
import ConfectionServiceRowForm from './ConfectionServiceRowForm.vue';
import NDEConfectionRowForm from './NDEConfectionRowForm.vue';
import NDEConfectionHeaderForm from './NDEConfectionHeaderForm.vue';
import NDEConfectionGrantingForm from './NDEConfectionGrantingForm.vue';
import NDEConfectionEnvelopeLayoutForm from './NDEConfectionEnvelopeLayoutForm.vue';
import NDEConfectionSplitCriteriaForm from './NDEConfectionSplitCriteriaForm.vue';
import NDEConfectionPersonalizationForm from './NDEConfectionPersonalizationForm.vue';
import ConfectionModal from '@/components/Modals/ConfectionModal.vue';
import {
  checkProductsIsEVoucher,
  checkProductsIsVirtualCard,
  checkProductsIsConfectionService,
  checkProductIsConfectionMany,
  checkProductsIsMarketingProduct,
  checkProductIsNDEExternalDistribution,
  checkProductsIsCoupon,
  PHYSICAL_CARD_CATEGORY,
  VIRTUAL_CARD_CATEGORY,
  NDE_PHYSICAL_CATEGORY,
  NDE_CONFECTION,
} from '@/utils/categoryUtils';
import { confectionContractType, confectionType } from '@/utils/constants/confection';
import {
  getConfectionHeader,
  getNDEConfectionTypeOrder,
  getNDEConfectionByType,
  hasNDEConfectionByType,
  isConfectionAmountEnterable,
  isConfectionTypeExclusive,
  isConfectionReadOnly,
  isAnyNDEConfectionSelected,
  getSelectedNDEConfectionIdsByType,
} from '@/utils/confection/nde';
import { isIndividualContractChosen } from '@/utils/contract/nde';
import LogoPersonalizationAlert from '../LogoPersonalizationAlert.vue';
import { confectionModalMixin } from '../Modals/confectionModalMixin';

export default {
  name: 'ProductForm',
  props: {
    delivery_id: {
      type: Number,
      required: true,
    },
    main: {
      type: Boolean,
      default: false,
    },
    hideMainProduct: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [confectionModalMixin],
  data() {
    return {
      confectionSelections: [],
      isConfectionEnabled: null,
    };
  },
  created() {
    this.confectionType = confectionType;
    if (this.currentStep === this.stepType.START) {
      this.isConfectionEnabled = this.isNDEConfectionEnabled;
      if (this.getProductsConfectionService) {
        this.confectionSelections = new Array(this.getProductsConfectionService.length).fill(false);
      }
    }
  },
  components: {
    ConfectionRowForm,
    ConfectionServiceRowForm,
    NDEConfectionRowForm,
    NDEConfectionHeaderForm,
    NDEConfectionGrantingForm,
    NDEConfectionEnvelopeLayoutForm,
    NDEConfectionSplitCriteriaForm,
    NDEConfectionPersonalizationForm,
    ProductRowForm,
    ConfectionModal,
    CustomAlert,
    LogoPersonalizationAlert,
  },
  computed: {
    ...mapState({
      stepType: state => state.steps.stepType,
      selectedExclusiveItem: state => state.confection.selectedExclusiveItem,
      selectedConfectionItems: state => state.confection.selectedConfectionItems,
      hasIndividualPersonalization: state => state.confection.hasIndividualPersonalization,
    }),
    hasIndividualContract() {
      return isIndividualContractChosen();
    },
    isVirtualCard() {
      return checkProductsIsVirtualCard(this.$store.state.products.all.products[0]);
    },
    getProducts() {
      return this.$store.getters.deliveriesProducts(this.delivery_id);
    },
    product() {
      return this.getProducts[0];
    },
    getProductsConfection() {
      if (this.product.confection.length > 0) {
        return this.product.confection;
      }
      return [];
    },
    getProductsConfectionService() {
      let result;
      if (this.product.confection.length > 0) {
        result = this.product.confectionService.filter(item => !checkProductIsConfectionMany(item));
      }
      return result;
    },
    getSelectedConfectionService() {
      const selectedConfectionIds = this.$store.getters['delivery/getItemsTotal']
        .filter(checkProductsIsConfectionService)
        .map(item => item.id);
      const selectedItems = this.product.confectionService.filter(item => selectedConfectionIds.includes(item.idproducts));
      return selectedItems;
    },
    getSelectedConfection() {
      const selectedConfectionIds = this.$store.getters['delivery/getOnlyConfectionItems']
        .filter(checkProductsIsMarketingProduct)
        .map(item => item.id);
      const selectedItems = this.getProductsConfection.filter(item => selectedConfectionIds.includes(item.idproducts));
      return selectedItems;
    },
    canAddLine() {
      const deliveryProduct = this.$store.getters.deliveriesProducts(this.delivery_id);
      if (deliveryProduct.length === 0) return false;
      const category = deliveryProduct[0].product_category;
      return (
        category === PHYSICAL_CARD_CATEGORY
        || category === NDE_PHYSICAL_CATEGORY
        || category === VIRTUAL_CARD_CATEGORY
        || checkProductIsNDEExternalDistribution(deliveryProduct[0])
      );
    },
    getPromoProducts() {
      const promoProduct = this.$store.getters.getPromoProducts;
      if (checkProductsIsEVoucher(this.$store.state.products.all.products[0]) || !promoProduct) {
        return [];
      }
      return [promoProduct];
    },
    checkIsConfectionAvailable() {
      return !!this.$store.state.products.all.products[0].confection.length || !!this.$store.state.products.all.products[0].confectionService.length;
    },
    currentStep() {
      return this.$store.state.steps.currentStep;
    },
    confectionHeader() {
      const isCoupon = checkProductsIsCoupon(this.$store.state.products.all.products[0]);
      return isCoupon ? 'Koperta ozdobna' : 'Etui ozdobne';
    },
    getIncompleteNDEConfectionMessage() {
      const confectionCompleteness = this.product.confectionContractInfo;
      if (confectionCompleteness === confectionContractType.PARTIAL) return 'Obecnie na Twoim kontrakcie indywidualnym znajdują się tylko poniższe usługi dodatkowe.<br />Jeśli chcesz  je zmodyfikować - <b>skontaktuj się z Twoim opiekunem Pluxee.</b>';
      if (confectionCompleteness === confectionContractType.NONE) return 'Obecnie na Twoim kontrakcie indywidualnym nie znajduje się żadna usługa dodatkowa.<br />Jeśli jesteś zainteresowany zakupem usługi dodatkowej takiej jak np. etui ozdobne, personalizacja etui lub personalizacja koperty - <b>skontaktuj się z Twoim opiekunem Pluxee</b>';
      return '';
    },
    hasContractIndividualConfection() {
      return this.product.confectionContractInfo !== confectionContractType.ALL;
    },
    hasProductNDEConfection() {
      return this.product.is_nde;
    },
    hasPersonalizedConfectionInCart() {
      return this.$store.getters['delivery/hasPersonalizedConfectionInCart'];
    },
    isNDEConfectionEnabled() {
      if (!this.hasProductNDEConfection) return false;
      return !!this.selectedExclusiveItem;
    },
    showSelectedConfectionTable() {
      if (this.hasProductNDEConfection) {
        return isAnyNDEConfectionSelected(this.$store.getters['delivery/getOnlyConfectionItems']);
      }
      return (
        this.getSelectedConfection.length !== 0 || this.getSelectedConfectionService.length !== 0
      );
    },
  },
  methods: {
    getNDEConfectionTypeOrder,
    getConfectionHeader,
    getNDEConfectionByType,
    hasNDEConfectionByType,
    isConfectionAmountEnterable,
    isConfectionTypeExclusive,
    isConfectionReadOnly,
    getSelectedNDEConfectionByType(type) {
      const ids = getSelectedNDEConfectionIdsByType(
        this.$store.getters['delivery/getOnlyConfectionItems'],
        type,
      );
      const selectedItems = this.getNDEConfectionByType(this.product, type).filter(item => ids.includes(item.idproducts));
      return selectedItems;
    },
    hasSelectedNDEConfectionByType(type) {
      return this.getSelectedNDEConfectionByType(type).length > 0;
    },
    isConfectionItemSelected(item) {
      return this.selectedExclusiveItem === item.slug || !!this.selectedConfectionItems[item.slug];
    },
    isSelectedConfectionByCategory(item, category) {
      if (item.product_category !== category) return false;
      return this.isConfectionItemSelected(item);
    },
    shouldShowConfectionGranting(item) {
      return this.isSelectedConfectionByCategory(item, NDE_CONFECTION.GRANTING_REASON);
    },
    shouldShowLogoPersonalizationAlert(item) {
      return item.product_category === NDE_CONFECTION.LOGO;
    },
    shouldShowEnvelopeLayout(item) {
      return this.isSelectedConfectionByCategory(item, NDE_CONFECTION.ENVELOPE_LAYOUT);
    },
    shouldShowSplitCriteria(item) {
      return this.isSelectedConfectionByCategory(item, NDE_CONFECTION.SUBPACKAGES);
    },
    shouldShowEnvelopePersonalization(item) {
      return this.hasIndividualContract && this.isSelectedConfectionByCategory(item, NDE_CONFECTION.ENVELOPE_PERSONALISATION);
    },
    shouldShowEtuiPersonalization(item) {
      return this.hasIndividualContract && this.isSelectedConfectionByCategory(item, NDE_CONFECTION.ETUI_PERSONALISATION);
    },
    goToFirstStep() {
      this.$store.dispatch('steps/setCurrentStep', this.stepType.START);
    },
    handleItemSelect(val, i) {
      this.confectionSelections[i] = val;
      this.isConfectionEnabled = this.confectionSelections.some(Boolean);
    },
    addProduct() {
      const newProduct = Object.assign({}, this.product);
      this.$store.dispatch('addProduct', [newProduct, this.$props.delivery_id]);
    },
    /**
     * this function is fired by product-input component
     * @param {object} product - this is param is emitem from component
     */
    updateProduct(product) {
      this.$store.dispatch('updateProduct', product);
    },
    setIsConfectionEnabledInStore(value) {
      this.$store.dispatch('confection/handleSetConfectionEnabled', value);
    },
    ensureDefaultContractPersonalization() {
      // personalization in default contract should always be treated as individual
      if (!this.hasProductNDEConfection || this.hasIndividualContract) return;
      this.$store.dispatch('confection/resetPersonalization', this.hasPersonalizedConfectionInCart);
    },
    ensureIndividualContractPersonalization() {
      if (!this.hasProductNDEConfection || !this.hasIndividualContract) return;
      if (this.hasPersonalizedConfectionInCart) return;
      this.$store.dispatch('confection/resetPersonalization', false);
    },
  },
  watch: {
    hasProductNDEConfection: {
      immediate: true,
      handler() {
        this.ensureDefaultContractPersonalization();
      },
    },
    hasIndividualPersonalization() {
      this.ensureDefaultContractPersonalization();
    },
    hasPersonalizedConfectionInCart() {
      this.ensureDefaultContractPersonalization();
      this.ensureIndividualContractPersonalization();
    },
    isConfectionEnabled() {
      this.setIsConfectionEnabledInStore(this.isConfectionEnabled);
    },
    selectedExclusiveItem() {
      this.setIsConfectionEnabledInStore(this.isNDEConfectionEnabled);
    },
  },
};
</script>

<style lang="scss" scoped>
#isConfectionEnabled {
  margin-left: 15px;
}
.app-confection-modal__link {
  width: fit-content;
}
</style>
